export default (() => {
  const lazyImages = document.querySelectorAll('.lazyload, .lazyload-bg')

  function lazyLoad() {
    lazyImages.forEach((el) => {
      if (isElementInViewport(el)) {
        if (el.classList.contains('lazyload')) {
          el.src = el.getAttribute('data-src')
        } else if (el.classList.contains('lazyload-bg')) {
          el.style.backgroundImage = `url(${el.getAttribute('data-src')})`
        }
        el.classList.remove('lazyload', 'lazyload-bg')
      }
    })
  }

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect()
    const scrollTop = window.scrollY
    return (
      scrollTop > rect.top - (window.innerHeight - 10) ||
      rect.top < window.innerHeight - 10
    )
  }

  window.addEventListener('scroll', lazyLoad)

  lazyLoad()
})()
